export var findNextFormat=function(formatsList,until){return formatsList.find(function(formatItem){return until>=formatItem.second})};
//# sourceMappingURL=findNextFormat.js.map